<template>
	<div class="sort-big-class">
		<el-table class="sort-class-table" :data="enableData" border height="100%">
			<el-table-column
				label="序号"
				type="index"
				align="center"
				width="50">
			</el-table-column>
			<el-table-column align="center"
				prop="name"
				label="店铺级小类名称"
				min-width="180">
			</el-table-column>
			<el-table-column label="操作" align="center" min-width="180">
				<template slot-scope="scope">
					<el-button
						icon="el-icon-caret-top"
						size="mini"
						type="primary"
						@click="upHandle(scope.$index, scope.row)">上移</el-button>
					<el-button
						icon="el-icon-caret-bottom"
						size="mini"
						type="primary"
						@click="downHandle(scope.$index, scope.row)">下移</el-button>
					<el-button
						icon="el-icon-upload2"
						size="mini"
						type="danger"
						@click="topHandle(scope.$index, scope.row)">置顶</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div slot="footer" class="dialog-footer">
			<el-button size="medium" @click="onCancelClick">取 消</el-button>
			<el-button type="primary" size="medium" @click="onSaveClick">保 存</el-button>
		</div>
	</div>
</template>

<script>
export default {
	name: 'sortBigClass',
	props: {
		visibleFlag: Boolean,
		data: {
			type: Array,
			default: () => {}
		}
	},
	data () {
		return {
			enableData: [],
			disableData: []
		}
	},
	watch: {
		data: {
			handler (val) {
				this.enableData = this.data
			},
			immediate: true
		}
	},
	methods: {
		refreshData () {
			this.$emit('refreshData')
		},
		onCancelClick () {
			this.$emit('update:visibleFlag', false)
		},
		onSaveClick () {
			let ids = this.enableData.map(e => {
				return e.id
			})
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/sortShopCategory`,
				data: ids
			}).then(res => {
				if (res.result) {
					this.$message({
						message: '二级分类排序成功!',
						type: 'success'
					})
					this.$emit('update:visibleFlag', false)
					this.refreshData()
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		upHandle (index, row) {
			if (index === 0) {
				return false
			}
			this.moveArr(this.enableData, index, index - 1)
		},
		downHandle (index, row) {
			if (index === this.enableData.length - 1) {
				return false
			}
			this.moveArr(this.enableData, index, index + 1)
		},
		topHandle (index, row) {
			if (index === 0) {
				return false
			}
			this.topArr(this.enableData, index)
		},
		moveArr (arr, index1, index2) {
			arr[index1] = arr.splice(index2, 1, arr[index1])[0]
		},
		topArr (arr, index) {
			let item = arr.splice(index, 1)[0]
			arr.unshift(item)
		}
	}
}
</script>
<style scoped lang="stylus">
.sort-big-class {
	display:flex;
	flex-direction: column
	height:100%
	.sort-class-table {
		flex:1
		overflow:hidden
	}
	.dialog-footer {
		margin-top:15px
	}
}
</style>
<style lang="stylus">
.sort-big-class {
	.sort-class-table {
		.el-table__body-wrapper::-webkit-scrollbar {
			width: 10px;
			background-color: #F5F5F5;
		}
		.el-table__body-wrapper::-webkit-scrollbar-thumb {
			border-radius: 10px;
			-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
			background-color: #ccc;
		}
		.el-table__body-wrapper::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
			background-color: #F5F5F5;
			border-radius: 10px;
		}
	}
}
</style>
